import { render, staticRenderFns } from "./OpenLogin.vue?vue&type=template&id=633dc7e8&scoped=true&"
import script from "./OpenLogin.vue?vue&type=script&lang=js&"
export * from "./OpenLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633dc7e8",
  null
  
)

export default component.exports